module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAYAAACdKY9CAAAA70lEQVQokX3QvyuFcRTH8ZfHDYsQm0UWbpJ6ysBk9T8YxO0x+gcMSmRTskgWk8WP7t0kLDZF+QeUhd2Vga7hfr/6dnvyGc95v8/pnK6iKCSZwRYW0MIdNvAcgSyBZ3GFG1QxHoTr0AOVRDjAOk6T2h5esI+5dMMwRjvgmEuMYSgVevBRAgu3NAPzJ7yhFxMlQjVw76nQwg7OMZXA0zjDZiykRx8hxxMeQy3HIU46hf4gzGMXD2F7jmUMoIavCrrRwCsm8ZlsvQgDjlHHYoY19IVJKRzTxJL2W2sZVrGNnxI45lv7KSsZRnD/Dxxzi8FfK3kt/4jnD/oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back/nav/zh.png
// module id = Cgho
// module chunks = 1